<ion-app>
	<ion-menu
		*ngIf="showAppMenu"
		contentId="main-content"
		menuId="mainMenu"
		side="end"
		swipeGesture="false"
		type="overlay"
	>
		<ion-list>
			<ion-menu-toggle auto-hide="true">
				<ion-header class="main-menu-header">
					<ion-toolbar>
						<ion-title>
							{{
								menuService.isAccountShellRoute(router.url)
									? "FlaggerAI Account"
									: "FlaggerAI"
							}}
						</ion-title>
					</ion-toolbar>
				</ion-header>
			</ion-menu-toggle>
			<ng-container *ngIf="menuService.isAccountShellRoute(router.url); else publicMenu">
				<ion-menu-toggle
					auto-hide="true"
					*ngFor="let item of menuService.accountMenuItems()"
				>
					<ion-item
						(click)="
							item.navOnHome
								? menuService.scroll(item.page)
								: menuService.navigateTo(item.page)
						"
						[class.selected]="
							menuService.isActiveAccountRoute(item.page, router.url)
						"
					>
						<ion-label>
							{{ item.displayName }}
						</ion-label>
					</ion-item>
				</ion-menu-toggle>
			</ng-container>

			<ng-template #publicMenu>
				<ion-menu-toggle auto-hide="true" *ngFor="let item of publicMenuItems">
					<ion-item
						[routerLink]="item.page"
						routerLinkActive="selected"
						[routerLinkActiveOptions]="{ exact: item.page === '/' }"
					>
						<ion-label>
							{{ item.displayName }}
						</ion-label>
					</ion-item>
				</ion-menu-toggle>
				<ion-menu-toggle auto-hide="true">
					<ion-item
						routerLink="/login"
						[queryParams]="{ returnUrl: '/account' }"
					>
						<ion-label>Rider App</ion-label>
					</ion-item>
				</ion-menu-toggle>
			</ng-template>
		</ion-list>
	</ion-menu>

	<ion-router-outlet id="main-content"></ion-router-outlet>
	<app-image-lightbox></app-image-lightbox>
</ion-app>
